export const ENABLE_LEGACY_ACCESS_TOKEN = () =>
  typeof window !== "undefined"
    ? (window as unknown as Record<string, boolean>)[
    "_wbm_main_header_environment_token"
    ]
    : true;

export const BOOTSTRAP_DIGITAL_DATA = () =>
  typeof window !== "undefined"
    ? (window as unknown as Record<string, boolean>)[
    "_wbm_main_header_environment_digitData"
    ]
    : true;